























































































































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { ALForm } from '@/common/component.types';

import { ISystemError } from '@/models/error/error.types';
import { IInventoryAdvancePayment } from '@/models';

import {
  humanReadableFileSize,
  scrollToBottomOfHtmlElement,
  setErrorFromAxiosError
} from '@/utils/helpers';
import mixins from '@/utils/mixins';
import FormRules from '@/mixins/file-upload-rules';

import ErrorAlert from '../common/ErrorAlert.vue';
import AlDialog from '@/components/core/Dialog/ALDialog.vue';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import { inventoryAdvancePayment } from '@/store/inventory-advance-payment';

const baseMixins = mixins(FormRules);

export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'InventoryAdvancePaymentAddAttachmentsFormDialog',

    components: {
      AlDialog,
      DragDropFileInput,
      ErrorAlert
    },

    props: {
      inventoryAdvancePayment: {
        type: Object as PropType<IInventoryAdvancePayment>,
        required: true
      }
    },

    data() {
      return {
        isDialogActive: false,
        attachmentFormValid: false,

        isLoading: false,

        error: null as ISystemError | null,

        attachments: [] as File[]
      };
    },

    methods: {
      ...mapActions({
        addInventoryAdvancePaymentAttachments:
          'inventoryAdvancePayment/addInventoryAdvancePaymentAttachments'
      }),

      resetFormValidation(): void {
        if (this.$refs.form) {
          return this.$refs.form.resetValidation();
        }
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      open() {
        this.clearError();
        this.attachments = [];
        this.isDialogActive = true;

        this.resetFormValidation();
      },

      clearError(): void {
        this.error = null;
      },

      close() {
        this.isDialogActive = false;
      },

      uploadAttachments() {
        if (this.validateForm()) {
          this.clearError();

          this.isLoading = true;

          this.addInventoryAdvancePaymentAttachments({
            id: this.inventoryAdvancePayment.id,
            attachments: this.attachments
          })
            .then(() => {
              this.close();
            })
            .catch(error => {
              this.error = setErrorFromAxiosError(error);
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      },

      addAttachments(files: File[]) {
        this.clearError();
        const fileList = Array.from(files);

        fileList.forEach(file => {
          this.attachments.push(file);
        });

        this.$nextTick(() => {
          scrollToBottomOfHtmlElement('#scrollableAttachmentList');
        });
      },

      removeFileFromList(filesList: File[], file: File) {
        const indexOfFile = filesList.indexOf(file);
        filesList.splice(indexOfFile, 1);
      }
    }
  });
